export default {
    customer:     'Customer',
    subscription: 'Subscription',
    connector:    'Connector',
    discount:     'Discount',
    total:        'Total',
    usage:        'Usage',

    subscriptions: {
        subscription_information: 'Subscription Information',
    },

    services: {
        availability: 'Service Availability',
    },

    dashboard: {
        incidents_logbook: 'Logbook',
        incidents_logbook_link: 'Show full logbook',
        no_incidents: 'No logs available',
    },

    entities: {
        unknown:             'Unknown',
        customer:            'Customer',
        product:             'Product',
        order:               'Order',
        stock:               'Stock',
        order_status:        'Order status',
        special_price:       'Special price',
        shipment:            'Shipment',
        invoice:             'Invoice',
        customer_assortment: 'Customer assortment',
        company:             'Company',
        quote:               'Quote',
        credit:              'Credit',
        rma:                 'RMA',
        CUSTOM_1:            'CUSTOM_1',
        CUSTOM_2:            'CUSTOM_2',
        CUSTOM_3:            'CUSTOM_3',
        CUSTOM_4:            'CUSTOM_4',
        CUSTOM_5:            'CUSTOM_5',
        proxy_request:       'Proxy API request',
    },

    messages: {
        title:         'messages',
        use_as_filter: 'Use as filter',

        search: {
            filters: 'Filters',
            toggle:  'Search',
        },

        filters: {
            show_unhandled: 'Show unhandled messages',
        },

        statistics: {
            message_statistics_of: 'Message Statistics of workflow',
            errors:                'Errors',
            filtered:              'Filtered',
            success:               'Success',
            total:                 'Total',
            not_available:         'No statistics available',
        },

        details: {
            title:            'General Information',
            mark_handled:     'Handled',
            mark_not_handled: 'Not handled',
        },

        error: {
            title: 'Error Information',
        },

        filter: {
            title: 'Filter',
            description: 'This message is filtered by the following criteria:',
        }
    },

    instances: {
        please_select_instance: 'Please select a Conneqt Instance',
        select_instance:        'Select Instance',
        current_instance:       'Current Instance',
        available:              'Available',
    },

    connectors: {
        register_connector:          'Register connector',
        install_connector:           'Install connector',
        identifier:                  'Identifier',
        base_url:                    'Base url',
        base_path:                   'Base path',
        general_settings:            'General Settings',
        configuration:               'Configuration',
        configuration_not_available: 'Connector configuration not available',
        last_updated:                'Last updated',
        install:                     'Install connector',
        installing:                  'Installing connector, please wait...',
        cleanup:                     'We will try to automatically clean up any data from this failed installation, please try again.',
        search:                      'Search for a connector...',
        go_to_connector:             'Go to connector',

        notifications: {
            updated: 'Successfully updated connector',
        },

        installation_statuses: {
            pending:     'Pending',
            creating_site: 'Creating site for connector',
            site_created:  'Site created, starting installation',
            installing_git: 'Installing connector',
            git_installed: 'Connector installed',
            obtaining_certificate: 'Installing SSL certificate',
            starting_deployment: 'Starting deployment',
            failed: 'Failed....',
            completed: 'Completed',
        }
    },

    workflows: {
        name:      'Workflow',
        entity:    'Entity',
        connector: 'Connector',
        watcher:   'Watcher',

        filter_options: {
            all_workflows: 'all workflows',
        },
    },

    mappings: {
        name:    'Mapping',
    },
};
